import { Brand, Frame, Img } from "../headliner/DeckShell";
import { CinematicCover } from "../headliner/CinematicCover";
import { Wordmark, brandOf as recipient } from "./brands";

/* 01 Cover — felles kinematisk cover (CinematicCover). Brukerens (Lovable-stolen) copy: «700 of Norway's decision-makers in one room.
   One real business problem turned into working software — live with X.» */
export const Cover = ({ mottaker }) => {
  const b = recipient(mottaker);
  const name = mottaker || "the Build Partner";
  return (
    <CinematicCover
      lockup={<p className="bd-lockup" data-testid="bd-lockup"><Brand size={19} /><i>×</i><Wordmark name={mottaker || "Build Partner"} h={24} /></p>}
      label="Build Partnership"
      title={["One day. One room.", <span className="acc">Built live.</span>]}
      sub={<>700 of Norway's decision-makers in one room. One real business problem turned into working software — live with <b>{name}</b>.</>}
      index={[
        ["Date", "13 April 2027"],
        ["Venue", "Grieghallen, Bergen"],
        [mottaker ? "Prepared for" : "Audience", mottaker || "700 seats · invitation-only", mottaker ? "prep" : "", "hd-prepared"],
      ]}
      className={b ? "bd-branded" : ""}
    />
  );
};

/* 04 The summit — hva Norwegian AI Summit er, på én slide: fakta-ledger + salen som bevis */
const FACTS = [
  ["When", "13 April 2027 · one day"],
  ["Where", "Grieghallen, Bergen"],
  ["Who", "700 CEOs, board members, founders, investors and public-sector leaders. Deliberately limited."],
  ["Programme", "Main stage · Leadership programme · AI Experience · Summit Dinner"],
  ["Opening keynote", "Kevin O'Leary — proposed · availability confirmed"],
];

export const Summit = ({ nr, mottaker }) => (
  <Frame nr={nr} label="The summit" mottaker={mottaker} className="bd-summit">
    <h2 className="hd-h2 bd-h80 bd-summit-h" data-testid="bd-summit-h">One day. One room.<br />700 decision-makers.</h2>
    <ul className="bd-facts" data-testid="bd-facts">
      {FACTS.map(([k, v]) => (
        <li key={k}><span className="k">{k}</span><span className="v">{v}</span></li>
      ))}
    </ul>
    <figure className="bd-photo" data-testid="bd-summit-photo">
      <Img src="/images/vision-hall-keynote.webp" alt="Grieghallen main hall" draggable={false} />
      <figcaption>Grieghallen · main hall<small>Not another conference. One room where Norway's leaders set the direction on AI.</small></figcaption>
    </figure>
  </Frame>
);

/* 05 The headliner — Kevin som bevis på ambisjonsnivået, ikke tema */
const BLOCKS = [
  ["2.5 h", "On-site", "Main stage, conversation and executive access — designed, not squeezed in."],
  ["09:30", "Opening keynote", "The whole room in the same seat — from the first minute of the day."],
];

export const Headliner = ({ nr, mottaker, lead = "Proposed opening keynote. The international headliner sets the ambition level of the room — and the standard everything on stage is measured against. Including the live build." }) => (
  <Frame nr={nr} label="The headliner" mottaker={mottaker} className="hd-headliner bd-headliner">
    <div className="hd-photo">
      <Img src="/images/headliner/kevin-src-hi.webp" alt="Kevin O'Leary" draggable={false} />
    </div>
    <div className="hd-body">
      <h2 className="hd-name" data-testid="bd-headliner-name">Kevin O'Leary</h2>
      <p className="hd-lead">{lead}</p>
      <div className="hd-blocks" data-testid="bd-headliner-blocks">
        {BLOCKS.map(([t, l, d]) => (
          <div className="hd-block" key={l}>
            <span className="t">{t}</span>
            <span className="l">{l}</span>
            <span className="d">{d}</span>
          </div>
        ))}
      </div>
      <p className="hd-line" data-testid="bd-headliner-line">
        <span className="gul">Availability confirmed</span> for 13 April 2027 — proposed opening keynote; not yet contracted
      </p>
    </div>
  </Frame>
);
